import * as Scrivito from "scrivito"

import { KpiPage } from "./KpiPage"
import { KpiPageObjClass } from "./KpiPageObjClass"

Scrivito.provideComponent(KpiPageObjClass, KpiPage)
